module.exports = __webpack_public_path__ + "img/product-5.876e26aa.jpg";